import React, { useState, useRef, useEffect } from 'react';
import { CommonSliderProps } from 'types';
import CommonSlider from './CommonSlider';
import { Input } from 'antd';
import { SlidersHorizontal } from '@phosphor-icons/react';

const PriceRangeSlider: React.FC<CommonSliderProps> = ({
  value,
  width,
  onChange,
  min = 0,
  max = 100,
  disabled = false,
  title = 'Khoảng giá',
}) => {
  const [visible, setVisible] = useState(false);
  const [tempValue, setTempValue] = useState<number[]>(value ?? [min, max]);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (visible) setTempValue(value ?? [min, max]);
  }, [visible, value, min, max]);
  const handleApply = () => {
    onChange(tempValue);
    setVisible(false);
  };
  const handleReset = () => {
    setTempValue([min, max]);
    onChange([min, max]);
    setVisible(false);
  };

  return (
    <div className='relative w-full ' ref={wrapperRef}>
      <Input
        readOnly
        onClick={() => setVisible(!visible)}
        value={
          !visible && value?.[0] === min && value?.[1] === max
            ? ''
            : `${value?.[0]?.toLocaleString()} - ${value?.[1]?.toLocaleString()} VND`
        }
        placeholder='Mức giá'
        className='w-full h-[30px] xl:h-[36px] 2xl:h-[40px] border-none px-3 py-2 rounded-lg cursor-pointer'
        style={{ width: '100%', minWidth: width }}
        suffix={<SlidersHorizontal size={16} />}
      />
      {visible && (
        <div className='absolute z-[2] mt-2 shadow-lg'>
          <CommonSlider
            title={title}
            value={tempValue}
            onChange={setTempValue}
            min={min}
            max={max}
            disabled={disabled}
            onApply={handleApply}
            onReset={handleReset}
          />
        </div>
      )}
    </div>
  );
};

export default PriceRangeSlider;
